// Shared constants for the Operations Team Schedule.

export const SHIFT_STATUSES = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'unconfirmed', label: 'Unconfirmed' },
];

// Shift blocks are coloured by status (not location): scheduled = the light
// blue from the User Access Control "With overrides" card, confirmed = AirAgri
// green, unconfirmed = amber/yellow. { bg, text, border } per status.
export const SHIFT_STATUS_COLORS = {
  scheduled: { bg: '#dbeafe', text: '#1e40af', border: '#93c5fd' },
  confirmed: { bg: '#0B2A1B', text: '#ffffff', border: '#0B2A1B' },
  unconfirmed: { bg: '#fef3c7', text: '#92400e', border: '#fcd34d' },
};

export const shiftStatusColor = (status) =>
  SHIFT_STATUS_COLORS[status] || SHIFT_STATUS_COLORS.scheduled;

// Palette used to colour shift blocks by location/station. Locations are
// mapped to colours deterministically in the order they first appear.
export const STATION_PALETTE = [
  '#067647', // green
  '#096dd9', // blue
  '#531dab', // purple
  '#ad6800', // amber
  '#c41d7f', // magenta
  '#08979c', // cyan
];

// Build a stable location -> colour map from a list of shifts.
export const buildStationColors = (shifts) => {
  const colors = {};
  let i = 0;
  shifts.forEach((s) => {
    const key = s.location || 'Unassigned';
    if (!colors[key]) {
      colors[key] = STATION_PALETTE[i % STATION_PALETTE.length];
      i += 1;
    }
  });
  return colors;
};
